import { PrismicRichText } from "@prismicio/react";
import React from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import Link from "next/link";
import Image from "next/image";

const bodyComponent = {
  heading4: ({ children }) => (
    <h4 className="text-medium text-[#232629]">{children}</h4>
  ),
  heading5: ({ children }) => (
    <h5 className="text-medium text-[#232629]">{children}</h5>
  ),
  heading6: ({ children }) => (
    <h6 className="text-medium text-[#232629]">{children}</h6>
  ),
  paragraph: ({ children }) => (
    <p className="text-medium text-[#232629]">{children}</p>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
};

const Popup = ({
  title,
  content,
  callButtonIcon,
  callButtonLabel,
  callButtonLink,
  viewButtonLabel,
  viewButtonLink,
  onClose,
}) => {
  return (
    <div className="inset-0 px-[24px] py-[30px] md:px-[36px] md:py-[42px] xl:px-[46px] xl:py-[68px] bg-white">
      <IoCloseCircleOutline
        size={34}
        color="#646464"
        onClick={onClose}
        className="absolute cursor-pointer top-[14px] right-[14px]"
      />
      <div className="">
        <h3 className="font-title title-large">{title}</h3>

        <div className="mt-[12px] md:mt-[24px] mb-[30px]">
          <PrismicRichText field={content} components={bodyComponent} />
        </div>

        <div className="flex gap-[20px] items-center">
          <Link
            href={callButtonLink}
            className={`flex font-bold items-center justify-center gap-x-[4px] text-[#232629] text-button py-[16px] px-[24px] transition-all ease-linear 0.3s bg-[#EEB978] hover:bg-[#EEB978]`}
          >
            <Image src={callButtonIcon} width={20} height={20} alt="Phone" />
            {callButtonLabel}
          </Link>
          <Link href={viewButtonLink} className="text-[#232629] text-button">
            {viewButtonLabel}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Popup;
